import axios from 'axios';
import { useRef, useCallback } from 'react';
import ReactPlayer from 'react-player';

export default function ResponsiveVideo({url, src=url, updateAspect, ...props}) {
  const ref = useRef();
  const setRef = useCallback((player) => {
    ref.current = player;
    if (!ref.current) return;

    if (updateAspect && !src.includes('#aspect=')) {
      getVimeoAspectRatio(ref.current).then(({aspectRatio}) => aspectRatio && updateAspect(aspectRatio));
    }
  }, []);

  return (
    <ReactPlayer ref={setRef}
      src={src}
      fallback={<div>loading</div>}
      style={{width: '100%', height: 'auto', aspectRatio: aspectFromURL(src)}}
      controls
      {...props} />
  );
}

function aspectFromURL(url) {
  const hint = url.split('#aspect=')[1];
  if (hint) return hint;
  if (/youtube\.com\/shorts/.test(url)) return '9/16';
  if (/tiktok.com\//.test(url)) return '9/16';
  return '16/9';
}

async function getVimeoAspectRatio(player) {
  const [width, height] = await Promise.all([
    player?.api?.getVideoWidth?.(),
    player?.api?.getVideoHeight?.(),
  ]);
  return {width, height, aspectRatio: width / height};
}
